function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCopyi = function SvgCopyi(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "M8.04 6.378V4.653C8.04 3.74 8.78 3 9.695 3h7.96c.912 0 1.652.74 1.652 1.653v11.315c0 .913-.74 1.653-1.653 1.653h-1.725v1.726c0 .912-.74 1.653-1.653 1.653h-7.96a1.654 1.654 0 0 1-1.653-1.653V8.032c0-.913.74-1.654 1.653-1.654zm6.42 12.969V8.032a.184.184 0 0 0-.185-.184h-7.96a.184.184 0 0 0-.184.184v11.315c0 .1.083.183.184.183h7.96a.184.184 0 0 0 .184-.183m1.468-3.195h1.725a.183.183 0 0 0 .184-.184V4.653a.184.184 0 0 0-.184-.184h-7.96a.184.184 0 0 0-.183.184v1.725h4.765c.912 0 1.653.74 1.653 1.654z"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCopyi);
export default ForwardRef;